export type NonNullableDeep<T> = { [P in keyof T]-?: NonNullable<T[P]> };

export type RequiredProperties<T, P extends keyof T> = T & NonNullableDeep<Pick<T, P>>;

export const fieldNotNull = <T, Field extends keyof T>(value: T, field: Field): value is RequiredProperties<T, Field> =>
  value[field] !== undefined && value[field] !== null;

export const whereFieldIsNotNull = <T, Field extends keyof T>(values: T[] | null | undefined, field: Field): RequiredProperties<T, Field>[] =>
  values?.filter((value): value is RequiredProperties<T, Field> => fieldNotNull(value, field)) ?? [];